import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Button, ModalCenter } from 'Components';
import './JobsImportedModal.css';

const JobsImportedModal = props => (
  <div className="job-imported-modal">
    <ModalCenter>
      <div>{i18n.t('jobs:BeingImported')}</div>
      <div>{i18n.t('jobs:MakeChanges')}</div>
      <Button
        className="button--primary"
        onClick={() => props.setPageState({ isShowingImportedJobModal: false })}
      >
        {i18n.t('common:ok')}
      </Button>
    </ModalCenter>
  </div>
);

JobsImportedModal.propTypes = {
  setPageState: PropTypes.func,
};

export default JobsImportedModal;



// WEBPACK FOOTER //
// ./src/components/JobsImportedModal/JobsImportedModal.jsx